import {AddGlobalStyle, BaseComponent} from "react-vextensions";
import React from "react";

AddGlobalStyle(`
	.switch {
		position: relative;
		display: inline-block;
		width: 60px;
		height: 34px;
	}
	.switch input { display:none; }
	
	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		-webkit-transition: .4s;
		transition: .4s;
	}
	.slider:before {
		position: absolute;
		content: "";
		height: 26px;
		width: 26px;
		left: 4px;
		bottom: 4px;
		background-color: white;
		-webkit-transition: .4s;
		transition: .4s;
	}
	
	input:checked + .slider {
		background-color: #CA2712;
	}
	input:focus + .slider {
		box-shadow: 0 0 1px #FA2712;
	}
	
	input:checked + .slider:before {
		-webkit-transform: translateX(26px);
		-ms-transform: translateX(26px);
		transform: translateX(26px);
	}
	
	/* Rounded sliders */
	.slider.round { border-radius: 34px; }
	.slider.round:before { border-radius: 50%;}
`);

export class FancySwitch extends BaseComponent<{value: boolean, onChange: (val: boolean)=>any}, {}> {
	render() {
		let {value, onChange} = this.props;
		return (
			<label className="switch">
				<input type="checkbox" checked={value} onChange={e=>{
					onChange(e.currentTarget.checked);
				}}/>
				<span className="slider round"/>
			</label>
		);
	}
}